<template>
    <div class="row">
        <div class="col-12">
            <h4>{{$t('COMPANYDATA.password')}}</h4>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
            <form-input :placeholder="$t('COMPANYDATA.password')"
                        :elementID="'password'"
                        :containerClass="'form-group'"
                        :inputClass="'form-control-sm'"
                        :inputType="'password'"
                        :validator="$v.pass.password"
                        v-model="pass.password">
            </form-input>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
            <form-input :placeholder="$t('COMPANYDATA.repeatPassword')"
                        :elementID="'Repeat password'"
                        :containerClass="'form-group'"
                        :inputClass="'form-control-sm'"
                        :inputType="'password'"
                        :validator="$v.pass.repeatPassword"
                        v-model="pass.repeatPassword">
            </form-input>
        </div>
    </div>
</template>
<script>
import FormInput from '../../../../Shared/UI/Form/FormInput.vue';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
export default {
    name: 'password-data',
    props: {
        pass: {
            type: Object
        }
    },
    components: {
        FormInput
    },
    methods: {
        handleInput (value) {
            this.$emit('update:password', value);
        }
    },
    validations: {
        pass: {
            password: {
                required,
                minLength: minLength(4)
            },
            repeatPassword: {
                sameAsPassword: sameAs('password')
            }
        }
    }
    
};
</script>
